/**
 * Config Thunks
 *
 * Async thunks for onboarding configuration operations
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type OnboardingConfig } from '@contracts';
import { fetchOnboardingConfig as fetchOnboardingConfigApi } from '../api/configApi';
import { handleThunkError } from './thunkUtils';

// ============================================
// Thunks
// ============================================

/**
 * Fetch onboarding configuration
 */
export const fetchOnboardingConfigThunk = createAsyncThunk<
  OnboardingConfig,
  void,
  { rejectValue: string }
>('onboarding/fetchConfig', async (_, { rejectWithValue }) => {
  try {
    const config = await fetchOnboardingConfigApi();
    return config;
  } catch (error) {
    return rejectWithValue(
      handleThunkError(error, 'fetch onboarding config', 'Failed to fetch onboarding config'),
    );
  }
});
